import { connect } from 'react-redux';
import { getFirstName, getLastName, getUserName, getUserEmail } from 'dux/user/selectors';

export const mapStateToProps = state => ( {
    firstName: getFirstName( state ),
    lastName: getLastName( state ),
    userName: getUserName( state ),
    emailAddress: getUserEmail( state )
} );

export default connect( mapStateToProps );
